export default __webpack_public_path__ + "static/smoke1-1e95eacfb38ada648b31131e27afc241.png";